import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/RegistrationDelivery/${dossierId}`, method: 'GET', token: token })
}
